import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '@lx/shared/ui/button';
import { LowerCasePipe } from '@angular/common';

@Component({
  selector: 'lx-dropdown-country',
  standalone: true,
  imports: [DropdownModule, FormsModule, ButtonComponent, LowerCasePipe],
  templateUrl: './dropdown-country.component.html',
  styleUrls: ['./dropdown-country.component.scss'],
})
export class DropdownCountryComponent {
  @ViewChild('dropdown') dropdown: Dropdown | undefined;
  @Input() countryMap: any;
  @Input() options: any;
  @Input() selectedValue: any;
  @Input() pleaseSelect = '';
  @Input() optionLabel = '';
  @Input() placeholder = '';
  @Input() optionValue = '';
  @Input() filterBy = '';
  @Output() buttonClick = new EventEmitter();
  isOpened = false;

  getDropdownIcon() {
    return this.dropdown && this.dropdown.overlayVisible ? 'pi pi-chevron-up' : 'pi pi-chevron-down';
  }

  toggleDropdown(isOpened: boolean) {
    this.isOpened = isOpened;
  }
}
